// 合同管理
export const reportAuthOptions = [
  {
    value: 'RIGHT_TO_REPORT_DATA',
    label: '填报数据'
  }
];
